export enum ModelState { NoChanges, New, Changed, Deleted }